'use strict';

var _classCallCheck = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;
/**
 * @typedef {import('ipfs-core-types/src/pubsub').MessageHandlerFn} MessageHandlerFn
 *
 * @typedef {Object} Subscription
 * @property {MessageHandlerFn} handler
 * @property {AbortController} controller
 */


var SubscriptionTracker = /*#__PURE__*/function () {
  function SubscriptionTracker() {
    _classCallCheck(this, SubscriptionTracker);

    /** @type {Map<string, Subscription[]>} */
    this._subs = new Map();
  }
  /**
   * @param {string} topic
   * @param {MessageHandlerFn} handler
   * @param {AbortSignal} [signal]
   */


  _createClass(SubscriptionTracker, [{
    key: "subscribe",
    value: function subscribe(topic, handler, signal) {
      var _this = this;

      var topicSubs = this._subs.get(topic) || [];

      if (topicSubs.find(function (s) {
        return s.handler === handler;
      })) {
        throw new Error("Already subscribed to ".concat(topic, " with this handler"));
      } // Create controller so a call to unsubscribe can cancel the request


      var controller = new AbortController();

      this._subs.set(topic, [{
        handler: handler,
        controller: controller
      }].concat(topicSubs)); // If there is an external signal, forward the abort event


      if (signal) {
        signal.addEventListener('abort', function () {
          return _this.unsubscribe(topic, handler);
        });
      }

      return controller.signal;
    }
    /**
     * @param {string} topic
     * @param {MessageHandlerFn} [handler]
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(topic, handler) {
      var subs = this._subs.get(topic) || [];
      var unsubs;

      if (handler) {
        this._subs.set(topic, subs.filter(function (s) {
          return s.handler !== handler;
        }));

        unsubs = subs.filter(function (s) {
          return s.handler === handler;
        });
      } else {
        this._subs.set(topic, []);

        unsubs = subs;
      }

      if (!(this._subs.get(topic) || []).length) {
        this._subs.delete(topic);
      }

      unsubs.forEach(function (s) {
        return s.controller.abort();
      });
    }
  }]);

  return SubscriptionTracker;
}();

module.exports = SubscriptionTracker;